export enum CustomTableEventModel {
  REFRESH = 'REFRESH',
}
